// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Wt-z","tooltipWrapper":"Xt-z","icon":"Yt-z","tooltip":"Zt-z","content":"_t-z"};